'use client'

import type { PropsWithChildren } from 'react'

import { Heading } from '../../heading/heading.tsx'
import { Text } from '../../text/text.tsx'
import { useSectionHeaderContext } from './use-section-header.ts'

export type SectionHeaderTitleProps = PropsWithChildren

export const SectionHeaderTitle = ({ children }: SectionHeaderTitleProps) => {
  const { size } = useSectionHeaderContext()

  if (size === 'sm') {
    return (
      <Text as="h3" fontSize="lg" fontWeight="bold" textColor="primary">
        {children}
      </Text>
    )
  }

  return (
    <Heading
      fontSize={size === 'md' ? 'xl' : '2xl'}
      fontWeight="bold"
      textColor="primary"
    >
      {children}
    </Heading>
  )
}
